import styled from '@emotion/styled';
import { Divider, Tabs } from 'antd';
import { orderBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PRIMARY, YELLOW } from '../../../../shared/colors';
import { Layout } from '../../../shared/Layout';
import { OrdreAchat } from '../components/reporting/OrdreAchat';
import { OrdreVente } from '../components/reporting/OrdreVente';
import { TransactionEnCours } from '../components/reporting/TransactionE';
import { TransactionFinalise } from '../components/reporting/TransactionF';
import { getOperationReporting } from '../network';

const Container = styled.div`
  height: calc(100vh - 30px);
  display: flex;
  background-color: #1c2025;
  color: white;

  .bread-crum span {
    color: white;
  }

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #acacac;
    color: white;
  }

  .odd-row,
  .even-row {
    &:hover > td {
      background-color: ${YELLOW} !important;
      cursor: pointer;
      color: black; /* plus lisible */
    }
  }

  .content {
    padding: 50px;
    width: 100%;
    background-color: #1c2025;
    color: white;
  }
`;

export const ReportingPage = () => {
  // const [isLoading, setIsLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState('1');
  const [reportingData, setReportingData] = useState<any>();
  const connectedUser = useSelector((state: any) => state.userReducer).user;

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    await getOperationReporting(connectedUser.id).then(({ data }) => {
      setReportingData(data);
    });
    return;
  };

  return (
    <Layout>
      <Container>
        {/** Obtain 'current' values in Sidebar component */}
        <div className='content'>
          <h2 style={{ marginTop: 10, color: 'white' }}>
            Reporting des Opérations
          </h2>
          <Divider style={{ marginBottom: 10 }} />
          <Tabs
            defaultActiveKey='1'
            activeKey={tabIndex}
            style={{ color: 'white' }}
            type='line'
            onChange={(key: string) => setTabIndex(key)}
            size='small'
          >
            <Tabs.TabPane tab="Ordres d'Achat" key='1'>
              <OrdreAchat operations={reportingData?.ope_ACHAT || []} />
            </Tabs.TabPane>
            <Tabs.TabPane tab='Ordres de Vente' key='2'>
              <OrdreVente operations={reportingData?.ope_VENTE || []} />
            </Tabs.TabPane>
            <Tabs.TabPane tab='Transactions matchées' key='3'>
              <TransactionEnCours
                transactions={
                  orderBy(
                    reportingData?.transact_MATCH,
                    'created_at',
                    'desc',
                  ) || []
                }
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab='Transactions finalisées' key='4'>
              <TransactionFinalise
                transactions={
                  orderBy(reportingData?.transact_FIN, 'created_at', 'desc') ||
                  []
                }
              />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Container>
    </Layout>
  );
};
